import axios from "axios";
import {
  IdentificationDocumentData,
  LandingPageProxyGetPassportFormResponse,
  LandingPageProxyPassportFormData,
  LandingPageProxySavePassportFormData,
} from "../types/IdentificationForm";

export const getIdentificationFormPassengers = async (
  tripId: string
): Promise<LandingPageProxyGetPassportFormResponse> => {
  try {
    const { data } = await axios.get<LandingPageProxyGetPassportFormResponse>(
      `${process.env.REACT_APP_API}/landing-page-proxy/api/passport-form/${tripId}`
    );
    return data;
  } catch (error) {
    throw error;
  }
};

export async function saveIdentificationDocuments(
  tripId: string,
  identificationDocuments: IdentificationDocumentData[]
) {
  try {
    const passportFormData: LandingPageProxyPassportFormData[] =
      identificationDocuments.map((singleDocument) => {
        return {
          passengerId: singleDocument.passengerId,
          passportData: {
            countryCode: singleDocument.issueCountry,
            passportNumber: singleDocument.idNumber,
            expiryDate: singleDocument.dateOfExpiry,
          },
        };
      });
    const { data } = await axios.post<LandingPageProxySavePassportFormData>(
      `${process.env.REACT_APP_API}/landing-page-proxy/api/passport-form/${tripId}`,
      { passengers: passportFormData }
    );
    return data;
  } catch (error) {
    throw error;
  }
}
